module.exports = __webpack_public_path__ + "static/aqua-park-staff-visual-61ada54ffd5f3bf6b2cf4bf77fb5c8d2.png";